"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCsrfCookie = exports.refreshCsrfCookie = exports.CSRF_COOKIE_NAME = exports.generateCsrfToken = void 0;
var cookies_1 = require("../cookies");
function generateCsrfToken() {
    var token = Math.random().toString(36).substring(2, 12);
    // 1 in 200 times the above line will produce a 9 character string,
    //    so we'll check and re-run if needed.
    if (token.length < 10) {
        return generateCsrfToken();
    }
    return token;
}
exports.generateCsrfToken = generateCsrfToken;
exports.CSRF_COOKIE_NAME = 'csrf';
/**
 * Generates a new CSRF token and sets it in a cookie when called from a browser.
 * Returns the CSRF token.
 */
function refreshCsrfCookie(options) {
    if (options === void 0) { options = {}; }
    var token = generateCsrfToken();
    (0, cookies_1.setCookie)(exports.CSRF_COOKIE_NAME, token, __assign(__assign({}, options), { expires: 0.5 / 24 }));
    return token;
}
exports.refreshCsrfCookie = refreshCsrfCookie;
function getCsrfCookie() {
    return (0, cookies_1.getCookie)(exports.CSRF_COOKIE_NAME);
}
exports.getCsrfCookie = getCsrfCookie;
